import React from 'react';
import { getImageUrl } from '../../utils/imageUtils';

const ProfileView = ({  onSendRequest, profile, onBack, source }) => {
    if (!profile) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <p className="text-gray-500">No profile data available.</p>
            </div>
        );
    }

    const getProfileImageSrc = (imagePath) => {
        if (!imagePath) return '/avatars/1.png';
        if (imagePath.includes('avatars/')) return `/${imagePath}`;
        return getImageUrl(imagePath);
    };

    const handleGoBack = () => {
        onBack(source); // ensures we return to correct view
    };

 return (
  <div className="min-h-screen bg-white flex justify-center items-center px-4 py-8 relative">
    <div className="w-full max-w-3xl bg-white rounded-2xl shadow-lg overflow-hidden">

      <button
        onClick={handleGoBack}
        className="absolute top-12 left-6 z-20 bg-white/90 p-3 rounded-full shadow-lg hover:bg-white sm:top-8 md:top-12"
      >
        <svg
          className="w-6 h-6 text-gray-800"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      <div className="relative">
        <div className="w-full h-[400px] md:h-[500px] overflow-hidden">
          <img
            src={getProfileImageSrc(profile.image)}
            alt={profile.name}
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/60">
          <h2 className="text-2xl font-semibold text-white mb-1">
            {profile.name}, {profile.age}
          </h2>
          <p className="text-white/90">{profile.location}</p>
          <p className="text-white/90">Gender: {profile.gender}</p>
        </div>
      </div>

      <div className="p-6">
        <p className="text-gray-700 mb-6 text-base md:text-lg leading-relaxed">
          {profile.bio}
        </p>

        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-2">Experience Levels</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="bg-gray-50 p-6 rounded-xl shadow-md">
              <p className="text-sm text-gray-600">Hiking</p>
              <p className="font-medium capitalize text-gray-800">
                {profile.skills?.hiking || 'Beginner'}
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl shadow-md">
              <p className="text-sm text-gray-600">Running</p>
              <p className="font-medium capitalize text-gray-800">
                {profile.skills?.running || 'Beginner'}
              </p>
            </div>
          </div>
        </div>
      </div>

    </div> {/* closes .max-w-3xl */}
  </div>  
);

};

export default ProfileView;